import { DeviceInfo } from 'qunar-react-native';
import CryptoJS from 'crypto-js';
import getQpVersion from './getQpVersion';

const hybridId = 'cmn_order_rn';
const getClientJson = async () => 
    new Promise((resolve) => {
        DeviceInfo.getInfo(
            async (deviceInfo) => {
                const { sid, uid, gid, pid, cid, vid, isIOS, isAndroid } = deviceInfo;
                let type = '';
                if (isIOS) {
                    type = 'IOS';
                } else if (isAndroid) {
                    type = 'Android';
                } else {
                    type = 'other';
                }
                const random = String(Math.floor(Math.random() * 10)) + String(Math.floor(Math.random() * 10));
                const wordArray = CryptoJS.enc.Utf8.parse(uid);
                const uidd = CryptoJS.enc.Base64.stringify(wordArray);
                resolve({
                    sid,
                    uid: random + uidd,
                    encrypt: '1',
                    gid,
                    pid,
                    cid,
                    vid,
                    type,
                    // TODO atomversion.order 目前获取不到
                    catom: '',
                    qpVersion: await getQpVersion(hybridId),
                    pageType: 'rn',
                    scheme: DeviceInfo.scheme
                });
            }
        );
    });

export default getClientJson;
